import React from "react"
import PropTypes from "prop-types"
import { defineMessages } from "react-intl"
import CardContent from "@material-ui/core/CardContent"
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import { makeStyles } from "@material-ui/core/styles"
import Skeleton from "@material-ui/lab/Skeleton"
import useSmartFormat from "../i18n/useSmartFormat"

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(4)
  },
  inner: {
    fontSize: "32px",
    margin: theme.spacing(0.5)
  },
  flexBottom: {
    alignSelf: "flex-end"
  },
  contentSkeleton: {
    minHeight: "45px",
    minWidth: "100%"
  },
  subtitleSkeleton: {
    minHeight: "10px",
    minWidth: "100%"
  }
}))

const messages = defineMessages({
  filterButton: {
    defaultMessage: "Filter",
    id: "common.button.filter"
  }
})

const AnalyticsCard = (props) => {
  const classes = useStyles()
  const format = useSmartFormat()

  const { subtitle, text, textSecondary, filterHandler, filterDate } = props

  return (
    <Card className="data-widget-card">
      <CardContent className={classes.content}>
        <Box display="flex" alignItems="flex-end" flexWrap="wrap">
          {(text && (
            <Typography className={classes.inner} variant="h3">
              {format(text)}
            </Typography>
          )) || <Skeleton className={classes.contentSkeleton} />}
          {textSecondary && (
            <Box className="tag-label">
              <DescriptionOutlinedIcon />
              <Typography variant="caption">{format(textSecondary)}</Typography>
            </Box>
          )}
        </Box>
        {(subtitle && (
          <Typography className="data-widget-subtitle">
            {format(subtitle)}
          </Typography>
        )) || (
          <Box className="data-widget-subtitle">
            <Skeleton className={classes.subtitleSkeleton} />
          </Box>
        )}

        {filterHandler && (
          <Button
            className="filter-btn"
            size="small"
            variant="outlined"
            color="secondary"
            onClick={() => filterHandler(filterDate)}
          >
            {format(messages.filterButton)}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

const IntlShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
  description: PropTypes.string
})

AnalyticsCard.propTypes = {
  subtitle: PropTypes.oneOfType([IntlShape, PropTypes.string]),
  text: PropTypes.oneOfType([IntlShape, PropTypes.string]),
  textSecondary: PropTypes.oneOfType([IntlShape, PropTypes.string]),
  filterHandler: PropTypes.func,
  filterDate: PropTypes.object
}

AnalyticsCard.defaultProps = {
  subtitle: undefined,
  text: undefined,
  textSecondary: undefined,
  filterHandler: undefined,
  filterDate: undefined
}

export default AnalyticsCard
